import { CSSProperties, FC, useMemo, useRef } from "react"

export type SpriteStates = "ready" | "run" | "sprint" | "jog" | "stand" | "tripped" | "hotdog"

interface Props {
	team: string
	state: SpriteStates
	animationDuration?: number
	animationDelay?: number
}

const Sprite: FC<Props> = ({ team, state, animationDuration, animationDelay }) => {
	const style = useMemo(() => {
		const out: CSSProperties = {}
		if (animationDuration !== undefined) {
			out.animationDuration = `${animationDuration}ms`
		}
		if (animationDelay !== undefined) {
			out.animationDelay = `-${animationDelay}ms`
		}
		return out
	}, [animationDuration, animationDelay])

	return <div className="team-sprite" data-team={team} data-state={state} style={style}></div>
}

export default Sprite
